// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__27pR9","cardImage":"Card_cardImage__3fqaZ","appearCard":"Card_appearCard__3dgR2","appear-card":"Card_appear-card__2tcPD"};